export enum FinancialLiteracyQuizType {
  MINOR = 'MINOR',
  YOUTH = 'YOUTH',
  SENIOR_CITIZEN = 'SENIOR_CITIZEN',
}

export const BOB_QUIZ_QUESTION_LIMIT = 5;

export const getRandomSubset = <T>(arr: T[], count: number): T[] => {
  const shuffled = [...arr].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
};

export const getAgeFromMaskedDob = (maskedDateOfBirth?: string): number | null => {
  if (!maskedDateOfBirth) return null;
  const yearMatch = maskedDateOfBirth.match(/(\d{4})$/);
  if (!yearMatch) return null;
  const year = Number(yearMatch[1]);
  if (Number.isNaN(year)) return null;

  const currentYear = new Date().getFullYear();
  const age = currentYear - year;
  if (age < 0 || age > 120) return null;
  return age;
};

export const getFinancialLiteracyQuizTypeByDob = (
  maskedDateOfBirth?: string
): FinancialLiteracyQuizType => {
  const age = getAgeFromMaskedDob(maskedDateOfBirth);
  if (age === null) return FinancialLiteracyQuizType.YOUTH;
  if (age < 18) return FinancialLiteracyQuizType.MINOR;
  if (age >= 60) return FinancialLiteracyQuizType.SENIOR_CITIZEN;
  return FinancialLiteracyQuizType.YOUTH;
};
